module.exports = __webpack_public_path__ + "img/uno-logo.b761cb80.png";